import { animate, sequence, state, style, transition, trigger } from '@angular/animations';

export const fadeIn = trigger('fadeIn', [
  transition(':enter', [
    style({ opacity: 0, visibility: 'hidden' }), // Initial state
    animate('0.7s cubic-bezier(0.4, 0.0, 0.2, 1)', style({ opacity: 1, visibility: 'visible' })), // Final state
  ]),
]);

export const fadeInOut = trigger('fadeInOut', [
  transition(':enter', [
    style({ opacity: 0 }),
    animate('0.7s cubic-bezier(0.4, 0.0, 0.2, 1)', style({ opacity: 1 })),
  ]),
  transition(':leave', [
    style({ opacity: 1 }),
    animate('0.7s cubic-bezier(0.4, 0.0, 0.2, 1)', style({ opacity: 0 })),
  ]),
]);

export const delayFadeIn = trigger('delayFadeIn', [
  transition('', [
    style({ opacity: 0, visibility: 'hidden' }),
    sequence([
      animate('0s 3s', style({ visibility: 'visible' })), // Stay hidden for 3 seconds
      animate('2s', style({ opacity: 1 })), // Fade in over 2 seconds
    ]),
  ]),
]);

export const toggleFade = [
  trigger('toggleFade', [
    state('true', style({ opacity: 1, visibility: 'visible' })),
    state('false', style({ opacity: 0, visibility: 'hidden' })),
    transition('false => true', [
      animate('0s 3s', style({ visibility: 'visible' })), // Stay hidden for 3 seconds
      animate('2s', style({ opacity: 1 })), // Fade in over 2 seconds
    ]),
    transition('true => false', [
      animate('2s', style({ opacity: 0, visibility: 'hidden' })), // Fade out over 2 seconds
    ]),
  ]),
];
